import Vue from 'vue';
import VueAmap from 'vue-amap';

Vue.use(VueAmap);

export default () => {
  VueAmap.initAMapApiLoader({
    key: 'b04e6c72a4c0783e2e2500b3bec8d43c',
    v: '1.4.4'
  });
};
